import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IExchangeProgramNames, SsapData } from '@components/ssap/SsapTypes';
import externalEndpoints from '@constants/configs/externalEndpoints';

interface IOutsideParentAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    exchangeAndProgramNames: IExchangeProgramNames,
    formName: string,
    isAsteriskShown: boolean
}

const OutsideParentAttestation = (props: IOutsideParentAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            taxHousehold: {
                medicaidConsent
            }
        },
        exchangeAndProgramNames,
        formName,
        isAsteriskShown = true
    } = props;
    
    const { exchangeMedicaid } = exchangeAndProgramNames;
    const className = classNames({
        'required-true': isAsteriskShown
    });

    return (
        <UniversalInput
            label = { {
                text: 'ssap.input.label.acknowledge_outside_parent',
                labelClass: [ className ],
                labelTextReplacements: {
                    link: (
                        <a
                            className = 'usa-link--external'
                            href = { externalEndpoints.MN_LINKS.OUTSIDE_PARENT_LINK }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            <FormattedMessage id = 'ssap.sign_and_review.outside_parent_link' />
                        </a>
                    ),
                    exchangeMedicaid
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'medicaidConsent',
                classes: [ 'disp-styl' ],
                checked: medicaidConsent,
                value: medicaidConsent,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'taxHousehold' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default OutsideParentAttestation;